import React from 'react'
import { shallow } from 'enzyme'
import { PipelineLayout } from '../PipelineLayout'

describe('<PipelineLayout />', () => {
  let wrapper, instance, props
  beforeEach(() => {
    props = {
      loans: [],
      data: {}
    }
    window.localStorage = {
      getItem: () => '{}',
      setItem: () => {}
    }
    wrapper = shallow(<PipelineLayout {...props} />)
    instance = wrapper.instance()
  })
  describe('#toggleDraggable', () => {
    describe('when isDraggable is false', () => {
      beforeEach(() => {
        wrapper.setState({ isDraggable: false })
      })
      it('should change isDraggable to true', () => {
        instance.toggleDraggable()
        expect(wrapper.state('isDraggable')).toBe(true)
      })
    })
    describe('when isDraggable is true', () => {
      beforeEach(() => {
        wrapper.setState({ isDraggable: true })
      })
      it('should change isDraggable to false', () => {
        instance.toggleDraggable()
        expect(wrapper.state('isDraggable')).toBe(false)
      })
    })
  })
})
